import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../../common/action-namespace';
import { ConversationToastMessage } from '../models';

const withNameSpace = withGenesysCloudStoreNameSpace('Conversation Toast messages');

export const openConversationToastMessage = createAction(
  withNameSpace('Open conversation toast message'),
  props<{ toastMessage: ConversationToastMessage }>()
);

export const closeConversationToastMessage = createAction(
  withNameSpace('Close conversation toast message'),
  props<{ conversationId: string, toastMessageId: string }>()
);

export const closeAllOtherConversationToastMessages = createAction(
  withNameSpace('Close all other conversation toast messages'),
  props<{ conversationId: string }>()
);
